import axios from 'axios';
import { getHeaders } from '../utils/headers';

export const searchPodcasts = async (params) => {
  const response = await axios.get(`/api/top-podcasts/search`, { params });
  return response.data;
};

export const getTopPodcasts = async (params) => {
  const response = await axios.get(`/api/top-podcasts/`, { params });
  return response.data;
};

export const getPodcastsByGenre = async (params) => {
  const response = await axios.get(`/api/top-podcasts/by-genre`, { params });
  return response.data;
};

export const getPodcastReleaseDate = async (params) => {
  const response = await axios.get(`/api/top-podcasts/get-release-date`, { params });
  return response.data;
};

export const getGenres = async (params) => {
  const response = await axios.get(`/api/top-podcasts/genres`, { params });
  return response.data;
};

export const getCountries = async (params) => {
  const response = await axios.get(`/api/top-podcasts/countries`, { params });
  return response.data;
};

export const getTopPodcastsForDemo = async (params) => {
  const response = await axios.get(`/api/top-podcasts/demo`, { params });
  return response.data;
};

export const getSubscribers = async (params) => {
  const headers = getHeaders();
  const response = await axios.get('/api/top-podcasts/subscribers', { params, headers });
  return response.data;
};

export const saveAnnouncement = async (announcement) => {
  const headers = getHeaders();
  const response = await axios.post('/api/top-podcasts/announcement', { announcement }, { headers });
  return response.data;
};

export const getAnnouncement = async () => {
  const headers = getHeaders();
  const response = await axios.get('/api/top-podcasts/announcement', { headers });
  return response.data;
};

export const getCachedData = async () => {
  const response = await axios.get('/api/top-podcasts/get-cached-podcast');
  return response.data;
};

export const savePodNews = async (podNews) => {
  const headers = getHeaders();
  const response = await axios.post('/api/top-podcasts/podnews', { podNews }, { headers });
  return response.data;
};

export const getPodNews = async () => {
  const headers = getHeaders();
  const response = await axios.get('/api/top-podcasts/podnews', { headers });
  return response.data;
};

export const trackEvent = async (payload) => {
  const response = await axios.post('/api/top-podcasts/track', payload);
  return response.data;
};
